export default "__VITE_ASSET__DxJHIOFm__"